/** Onglets paramètres compte (page pleine). */
export type AccountSettingsTab = "folders" | "identity" | "connection";

/**
 * Focus d’ouverture — onglets actuels + alias historiques
 * (`navigation` → dossiers, `account` → connexion & données).
 */
export type AccountSettingsFocus = AccountSettingsTab | "navigation" | "account";

export function normalizeAccountSettingsFocus(
  focus: AccountSettingsFocus | undefined
): AccountSettingsTab {
  if (focus === "identity") return "identity";
  if (focus === "connection" || focus === "account") return "connection";
  return "folders";
}
